import React from "react";

export const SocialMediaIconAndLable = ({ icon, name }) => {
  return (
    <div className="flex items-center ">
      <img
        src={icon}
        alt={`social media icon for ${icon} `}
        className="h-6 w-6"
      />
      <span className="text-md ps-2">{name}</span>
    </div>
  );
};
